import React, { useEffect, useRef, useState } from "react";

const BLUE = "#2f6bff";
const PUPIL = "#12327a";

function Eye({ px, animated, look }) {
  const p = px * 0.36, base = (px - p) / 2 - Math.max(2, px * 0.14), r = px * 0.17;
  return (
    <span className="relative inline-block" style={{ width: px, height: px, marginLeft: -px * 0.06 }}>
      <span className="absolute inset-0 rounded-full" style={{ background: "#fff", border: `${Math.max(2, px * 0.14)}px solid ${BLUE}` }} />
      {animated
        ? <span className="absolute rounded-full logo-pupil-look" style={{ width: p, height: p, background: PUPIL, top: px * 0.30, right: px * 0.16, "--eye": `${px * 0.32}px` }} />
        : <span className="absolute rounded-full" style={{ width: p, height: p, background: PUPIL, top: base + Math.max(2, px * 0.14), left: base + Math.max(2, px * 0.14), transform: `translate(${look.x * r}px, ${look.y * r}px)`, transition: "transform 0.25s ease-out" }} />}
    </span>
  );
}

const REST = { x: 0.55, y: -0.25 };
const rand = () => ({ x: Math.random() * 2 - 1, y: Math.random() * 1.6 - 0.8 });

// Le due "oo" di Markoo sono occhietti: seguono il mouse e ogni tanto si guardano intorno.
export function Logo({ size = 22, className = "", showText = true, animated = false, wander = false }) {
  const ref = useRef(null);
  const [look, setLook] = useState(REST);
  const hover = useRef(false);
  useEffect(() => {
    if (animated) return undefined;
    let t;
    const tick = () => {
      t = setTimeout(() => {
        if (!hover.current) { setLook(rand()); setTimeout(() => { if (!hover.current) setLook(wander ? rand() : REST); }, wander ? 900 : 1100); }
        tick();
      }, wander ? 1800 + Math.random() * 1500 : 5000 + Math.random() * 5000);
    };
    tick();
    return () => { clearTimeout(t); };
  }, [animated, wander]);
  const onMove = (e) => {
    const b = ref.current?.getBoundingClientRect();
    if (!b) return;
    const cx = b.left + b.width * 0.45, cy = b.top + b.height / 2;
    const dx = e.clientX - cx, dy = e.clientY - cy, d = Math.max(1, Math.hypot(dx, dy));
    setLook({ x: dx / d, y: dy / d });
  };
  return (
    <span ref={ref} onMouseEnter={() => { hover.current = true; }} onMouseMove={animated ? undefined : onMove} onMouseLeave={() => { hover.current = false; setLook(REST); }}
      className={`inline-flex items-center font-head font-extrabold tracking-tight ${className}`} style={{ fontSize: size, lineHeight: 1 }} data-testid={animated ? "app-logo-busy" : "app-logo"}>
      <span style={{ color: BLUE }}>Mark</span>
      <span className="inline-flex items-center" style={{ margin: `0 ${size * 0.05}px` }}>
        <Eye px={size} animated={animated} look={look} /><Eye px={size} animated={animated} look={look} />
      </span>
      {showText && <span className="ml-1.5 text-foreground">Place</span>}
    </span>
  );
}

export function SimammaBadge({ className = "" }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-extrabold tracking-tight ${className}`}
      style={{ background: "rgba(47,107,255,0.14)" }} data-testid="simamma-badge">
      <span style={{ color: BLUE }}>SI</span><span className="text-orange-500">MAMMA</span>
    </span>
  );
}

export default Logo;
